import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { createStore, applyMiddleware } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import rootReducer from '../reducers'
import rootEpic from '../epics'
import LogRocket from 'logrocket'
import actions from '../actions'

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
})

export const getStore = () => {
  const composeEnhancers = composeWithDevTools({})
  const epicMiddleware = createEpicMiddleware()
  const routerMiddleware = createRouterMiddleware(history)

  const store = createStore(
    rootReducer(history),
    composeEnhancers(
      applyMiddleware(
        routerMiddleware,
        epicMiddleware,
        LogRocket.reduxMiddleware({
          actionSanitizer: function (action) {
            if (action.type === actions.SIGNIN_REQUESTED) {
              return null
            }
            return action
          },
        })
      )
    )
  )

  epicMiddleware.run(rootEpic)

  return store
}
